"use client"
import Footer from './Footer';
import PreHeader from './PreHeader';
import Header from './Header';
import Menu from './Menu';
import React,{useState,useEffect, useRef} from 'react'
import {RowsPhotoAlbum,RenderRowContainer} from "react-photo-album";

import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import ContactBanner  from './ContactBanner';
import { ProductProvider } from './Productcontext';

import Zoom from "yet-another-react-lightbox/plugins/zoom";
import { gsap } from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import ScrollToTopButton from './ScrollToTopButton';
import Image from "next/image"; 
import "./gallery.css";

/* Media Images */
import me_image1 from '../images/gallery/imge.jpg';
import me_image1_2x from '../images/gallery/imge@2x.jpg';
import me_image2 from '../images/gallery/image.jpg';
import me_image2_2x from '../images/gallery/image@2x.jpg';
import me_image3 from '../images/gallery/image2.jpg';
import me_image3_2x from '../images/gallery/image2@2x.jpg';

import me_big1 from '../images/gallery/IMG_0594.jpg';
import me_big2 from '../images/gallery/IMG_5534.jpg';
import me_big3 from '../images/gallery/IMG_5717.jpg';




/* milan photos */
import m1 from '../images/gallery/Milan/Small_Image/IMG_1837.jpg';
import m1_2x from '../images/gallery/Milan/Small_Image/IMG_1837@2x.jpg';
import m1_big from '../images/gallery/Milan/IMG_1837.jpg';

import m2 from '../images/gallery/Milan/Small_Image/IMG_1842.jpg';
import m2_2x from '../images/gallery/Milan/Small_Image/IMG_1842@2x.jpg';
import m2_big from '../images/gallery/Milan/IMG_1842.jpg';

import m3 from '../images/gallery/Milan/Small_Image/IMG_1850.jpg';
import m3_2x from '../images/gallery/Milan/Small_Image/IMG_1850@2x.jpg';
import m3_big from '../images/gallery/Milan/IMG_1850.jpg';

import m4 from '../images/gallery/Milan/Small_Image/IMG_1856.jpg';
import m4_2x from '../images/gallery/Milan/Small_Image/IMG_1856@2x.jpg';
import m4_big from '../images/gallery/Milan/IMG_1856.jpg';

import m5 from '../images/gallery/Milan/Small_Image/IMG_1864.jpg';
import m5_2x from '../images/gallery/Milan/Small_Image/IMG_1864@2x.jpg';
import m5_big from '../images/gallery/Milan/IMG_1864.jpg';

import m6 from '../images/gallery/Milan/Small_Image/IMG_1890.jpg';
import m6_2x from '../images/gallery/Milan/Small_Image/IMG_1890@2x.jpg';
import m6_big from '../images/gallery/Milan/IMG_1890.jpg';

import m7 from '../images/gallery/Milan/Small_Image/IMG_1925.jpg';
import m7_2x from '../images/gallery/Milan/Small_Image/IMG_1925@2x.jpg';
import m7_big from '../images/gallery/Milan/IMG_1925.jpg';

import m8 from '../images/gallery/Milan/Small_Image/IMG_1962.jpg';
import m8_2x from '../images/gallery/Milan/Small_Image/IMG_1962@2x.jpg';
import m8_big from '../images/gallery/Milan/IMG_1962.jpg';

import m9 from '../images/gallery/Milan/Small_Image/IMG_1964.jpg';
import m9_2x from '../images/gallery/Milan/Small_Image/IMG_1964@2x.jpg';
import m9_big from '../images/gallery/Milan/IMG_1964.jpg';

import m10 from '../images/gallery/Milan/Small_Image/IMG_1966.jpg';
import m10_2x from '../images/gallery/Milan/Small_Image/IMG_1966@2x.jpg';
import m10_big from '../images/gallery/Milan/IMG_1966.jpg';

import m11 from '../images/gallery/Milan/Small_Image/IMG_1995.jpg';
import m11_2x from '../images/gallery/Milan/Small_Image/IMG_1995@2x.jpg';
import m11_big from '../images/gallery/Milan/IMG_1995.jpg';

/*Events photos */
import E1 from '../images/gallery/Events/Small_Image/DSC_0038.jpg';
import E1_2x from '../images/gallery/Events/Small_Image/DSC_0038@2x.jpg';
import E1_big from '../images/gallery/Events/DSC_0038.jpg';

import E2 from '../images/gallery/Events/Small_Image/DSC_0044.jpg';
import E2_2x from '../images/gallery/Events/Small_Image/DSC_0044@2x.jpg';
import E2_big from '../images/gallery/Events/DSC_0044.jpg';

import E3 from '../images/gallery/Events/Small_Image/DSC_0045.jpg';
import E3_2x from '../images/gallery/Events/Small_Image/DSC_0045@2x.jpg';
import E3_big from '../images/gallery/Events/DSC_0045.jpg';

// import E4 from '../images/gallery/Events/Small_Image/DSC_0048.jpg';
// import E4_2x from '../images/gallery/Events/Small_Image/DSC_0048@2x.jpg';
// import E4_big from '../images/gallery/Events/DSC_0048.jpg';

import E5 from '../images/gallery/Events/Small_Image/DSC_0050.jpg';
import E5_2x from '../images/gallery/Events/Small_Image/DSC_0050@2x.jpg';
import E5_big from '../images/gallery/Events/DSC_0050.jpg';

import E6 from '../images/gallery/Events/Small_Image/DSC_0052.jpg';
import E6_2x from '../images/gallery/Events/Small_Image/DSC_0052@2x.jpg';
import E6_big from '../images/gallery/Events/DSC_0052.jpg';

import E7 from '../images/gallery/Events/Small_Image/DSC_0058.jpg';
import E7_2x from '../images/gallery/Events/Small_Image/DSC_0058@2x.jpg';
import E7_big from '../images/gallery/Events/DSC_0058.jpg';

import E8 from '../images/gallery/Events/Small_Image/DSC_0060.jpg';
import E8_2x from '../images/gallery/Events/Small_Image/DSC_0060@2x.jpg';
import E8_big from '../images/gallery/Events/DSC_0060.jpg';

import E9 from '../images/gallery/Events/Small_Image/Elecrama_2020-1.jpg';
import E9_2x from '../images/gallery/Events/Small_Image/Elecrama_2020-1@2x.jpg';
import E9_big from '../images/gallery/Events/Elecrama_2020-1.jpg';

import E10 from '../images/gallery/Events/Small_Image/IMG_0350.jpg';
import E10_2x from '../images/gallery/Events/Small_Image/IMG_0350@2x.jpg';
import E10_big from '../images/gallery/Events/IMG_0350.jpg';

import E11 from '../images/gallery/Events/Small_Image/IMG_0603.jpg';
import E11_2x from '../images/gallery/Events/Small_Image/IMG_0603@2x.jpg';
import E11_big from '../images/gallery/Events/IMG_0603.jpg';

import E12 from '../images/gallery/Events/Small_Image/IMG_1016.jpg';
import E12_2x from '../images/gallery/Events/Small_Image/IMG_1016@2x.jpg';
import E12_big from '../images/gallery/Events/IMG_1016.jpg';

import E13 from '../images/gallery/Events/Small_Image/IMG_2610.jpg';
import E13_2x from '../images/gallery/Events/Small_Image/IMG_2610@2x.jpg';
import E13_big from '../images/gallery/Events/IMG_2610.jpg';

import E14 from '../images/gallery/Events/Small_Image/IMG_2613.jpg';
import E14_2x from '../images/gallery/Events/Small_Image/IMG_2613@2x.jpg';
import E14_big from '../images/gallery/Events/IMG_2613.jpg';

import E15 from '../images/gallery/Events/Small_Image/IMG_2615.jpg';
import E15_2x from '../images/gallery/Events/Small_Image/IMG_2615@2x.jpg';
import E15_big from '../images/gallery/Events/IMG_2615.jpg';

import E16 from '../images/gallery/Events/Small_Image/IMG_2619.jpg';
import E16_2x from '../images/gallery/Events/Small_Image/IMG_2619@2x.jpg';
import E16_big from '../images/gallery/Events/IMG_2619.jpg';

import E17 from '../images/gallery/Events/Small_Image/kovai_expo.jpg';
import E17_2x from '../images/gallery/Events/Small_Image/kovai_expo@2x.jpg';
import E17_big from '../images/gallery/Events/kovai_expo_big.jpg';

/* Certificate Photos  */
import CE1 from '../images/gallery/Certificates/Small_Image/alice-digital-cpri.jpg';
import CE1_2x from '../images/gallery/Certificates/Small_Image/alice-digital-cpri@2x.jpg';
import CE1_big from '../images/gallery/Certificates/alice-digital-cpri.jpg';

import CE2 from '../images/gallery/Certificates/Small_Image/big-round-pit.jpg';
import CE2_2x from '../images/gallery/Certificates/Small_Image/big-round-pit@2x.jpg';
import CE2_big from '../images/gallery/Certificates/big-round-pit.jpg';

import CE3 from '../images/gallery/Certificates/Small_Image/certificate-of-compliance-E490020-20170314.jpg';
import CE3_2x from '../images/gallery/Certificates/Small_Image/certificate-of-compliance-E490020-20170314@2x.jpg';
import CE3_big from '../images/gallery/Certificates/certificate-of-compliance-E490020-20170314.jpg';

import CE4 from '../images/gallery/Certificates/Small_Image/cpri-19-1.jpg';
import CE4_2x from '../images/gallery/Certificates/Small_Image/cpri-19-1@2x.jpg';
import CE4_big from '../images/gallery/Certificates/cpri-19-1.jpg';

import CE5 from '../images/gallery/Certificates/Small_Image/cpri-39-1.jpg';
import CE5_2x from '../images/gallery/Certificates/Small_Image/cpri-39-1@2x.jpg';
import CE5_big from '../images/gallery/Certificates/cpri-39-1.jpg';

import CE6 from '../images/gallery/Certificates/Small_Image/cpri-aseel-50.jpg';
import CE6_2x from '../images/gallery/Certificates/Small_Image/cpri-aseel-50@2x.jpg';
import CE6_big from '../images/gallery/Certificates/cpri-aseel-50.jpg';

import CE7 from '../images/gallery/Certificates/Small_Image/electrodite-leachable-element-rest.jpg';
import CE7_2x from '../images/gallery/Certificates/Small_Image/electrodite-leachable-element-rest@2x.jpg';
import CE7_big from '../images/gallery/Certificates/electrodite-leachable-element-rest.jpg';

import CE8 from '../images/gallery/Certificates/Small_Image/electrodite-rohs.jpg';
import CE8_2x from '../images/gallery/Certificates/Small_Image/electrodite-rohs@2x.jpg';
import CE8_big from '../images/gallery/Certificates/electrodite-rohs.jpg';

import CE9 from '../images/gallery/Certificates/Small_Image/iso-test.jpg';
import CE9_2x from '../images/gallery/Certificates/Small_Image/iso-test@2x.jpg';
import CE9_big from '../images/gallery/Certificates/iso-test.jpg';

import CE10 from '../images/gallery/Certificates/Small_Image/thor-bt-tr-test.jpg';
import CE10_2x from '../images/gallery/Certificates/Small_Image/thor-bt-tr-test@2x.jpg';
import CE10_big from '../images/gallery/Certificates/thor-bt-tr-test.jpg';

import CE11 from '../images/gallery/Certificates/Small_Image/thor-cpri.jpg';
import CE11_2x from '../images/gallery/Certificates/Small_Image/thor-cpri@2x.jpg';
import CE11_big from '../images/gallery/Certificates/thor-cpri.jpg';

import CE12 from '../images/gallery/Certificates/Small_Image/thor-helios-test.jpg';
import CE12_2x from '../images/gallery/Certificates/Small_Image/thor-helios-test@2x.jpg';
import CE12_big from '../images/gallery/Certificates/thor-helios-test.jpg';

import gallery_banner from '../images/gallery/banner/gallery-banner.jpg';
import gallery_banner2x from '../images/gallery/banner/gallery-banner@2x.jpg';
import gallery_banner_360 from '../images/gallery/banner/gallery-banner_720.jpg';
import gallery_banner_tab from '../images/gallery/banner/gallery-banner_tab.jpg';
// import * as ReactPhotoAlbum from 'react-photo-album';
//console.log(ReactPhotoAlbum);
//gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);



const company_photos = [
  { src: `${me_image1.src}`, width: 237, height: 227,srcSet: [
    { src: `${me_image1.src}`, width: 237, height: 227 },
    { src: `${me_image1_2x.src}`, width: 474, height: 454 },
  ], 
  alt:"Ashlok exhibition booth Ashlok Safe Earthing Electrode Limited exhibition booth showcasing earthing and lightning protection solutions"
},
  { src: `${me_image2.src}`,width: 237, height: 227,
  srcSet: [
    { src: `${me_image2.src}`, width: 237, height: 227 },
    { src: `${me_image2_2x.src}`, width: 474, height: 454 },
    ],
    alt:"Ashlok Safe Earthing Electrode Limited head office and manufacturing facility"
  },
  { src: `${me_image3.src}`, width: 237, height: 227,
  srcSet: [
    { src: `${me_image3.src}`, width: 237, height: 227 },
    { src: `${me_image3_2x.src}`, width: 474, height: 454 },
  ],
alt:"Ashlok Safe Earthing Electrode Limited manufacturing facility for earthing electrodes and lightning protection systems"
},
  //  { src: `${smimage3}`, width: 237, height: 227,
  // srcSet: [
  //   { src: `${smimage3}`, width: 237, height: 227 },
  //   { src: `${smimage3_2x}`, width: 474, height: 454 },
  // ] }, { src: `${smimage3}`, width: 237, height: 227,
  // srcSet: [
  //   { src: `${smimage3}`, width: 237, height: 227 },
  //   { src: `${smimage3_2x}`, width: 474, height: 454 },
  // ] },{ src: `${smimage3}`, width: 237, height: 227,
  // srcSet: [
  //   { src: `${smimage3}`, width: 237, height: 227 },
  //   { src: `${smimage3_2x}`, width: 474, height: 454 },
  // ] }, { src: `${smimage3}`, width: 237, height: 227,
  // srcSet: [
  //   { src: `${smimage3}`, width: 237, height: 227 },
  //   { src: `${smimage3_2x}`, width: 474, height: 454 },
  // ] }, 
 
]
const company_photosfull = [
  { src: `${me_big1.src}` },
  { src: `${me_big2.src}` },
  { src: `${me_big3.src}` },
  
  // { src: `${bigimage3}` },
  // { src: `${bigimage3}` },
  // { src: `${bigimage3}` },
  // { src: `${bigimage3}` },
 
]


const milanPhotos = [
  { src: `${m1.src}`, width: 237, height: 227,srcSet: [
    { src: `${m1.src}`, width: 237, height: 227 },
    { src: `${m1_2x.src}`, width: 474, height: 454 },
  ], 
  alt:"Traditional lamp lighting at Ashlok event Ashlok Safe Earthing Electrode Limited lamp lighting ceremony at Milan 2019 event"
},
  { src: `${m2.src}`, width: 237, height: 227,srcSet: [
    { src: `${m2.src}`, width: 237, height: 227 },
    { src: `${m2_2x.src}`, width: 474, height: 454 },
  ], 
alt:"Traditional lamp lighting ceremony at Ashlok Safe Earthing Electrode Limited Milan 2019 event"
},
  { src: `${m3.src}`, width: 237, height: 227,srcSet: [
    { src: `${m3.src}`, width: 237, height: 227 },
    { src: `${m3_2x.src}`, width: 474, height: 454 },
  ], 
alt:"Audience at Ashlok Safe Earthing Electrode Limited Milan event"
},
  { src: `${m4.src}`, width: 237, height: 227,srcSet: [
    { src: `${m4.src}`, width: 237, height: 227 },
    { src: `${m4_2x.src}`, width: 474, height: 454 },
  ],
  alt:"Speaker addressing the audience at Ashlok Safe Earthing Electrode Limited Milan event"
},
  { src: `${m5.src}`, width: 237, height: 227,srcSet: [
    { src: `${m5.src}`, width: 237, height: 227 },
    { src: `${m5_2x.src}`, width: 474, height: 454 },
  ], alt:"Person speaking at Ashlok event.Ashlok Safe Earthing Electrode Limited event speaker at Milan 2019 celebration"
},
  { src: `${m6.src}`, width: 237, height: 227,srcSet: [
    { src: `${m6.src}`, width: 237, height: 227 },
    { src: `${m6_2x.src}`, width: 474, height: 454 },
  ],
alt:"Ashlok Safe Earthing Electrode Limited speaker addressing Milan 2019 audience"
},
  { src: `${m7.src}`, width: 237, height: 227,srcSet: [
    { src: `${m7.src}`, width: 237, height: 227 },
    { src: `${m7_2x.src}`, width: 474, height: 454 },
  ], 
alt:"Speaker at Ashlok Safe Earthing Electrode Limited Milan 2019 event"
},
  { src: `${m8.src}`, width: 237, height: 227,srcSet: [
    { src: `${m8.src}`, width: 237, height: 227 },
    { src: `${m8_2x.src}`, width: 474, height: 454 },
  ],
alt:"Participants attending the Ashlok Safe Earthing Electrode Limited Milan event"
},
  { src: `${m9.src}`, width: 237, height: 227,srcSet: [
    { src: `${m9.src}`, width: 237, height: 227 },
    { src: `${m9_2x.src}`, width: 474, height: 454 },
  ], 
alt:"Audience at Ashlok Safe Earthing Electrode Limited Milan event"
},
  { src: `${m10.src}`, width: 237, height: 227,srcSet: [
    { src: `${m10.src}`, width: 237, height: 227 },
    { src: `${m10_2x.src}`, width: 474, height: 454 },
  ],
alt:"Children participating at Ashlok Safe Earthing Electrode Limited Milan 2019 event"
},
  { src: `${m11.src}`, width: 237, height: 227,srcSet: [
    { src: `${m11.src}`, width: 237, height: 227 },
    { src: `${m11_2x.src}`, width: 474, height: 454 },
  ],
alt:"Group photo of participants at Ashlok Safe Earthing Electrode Limited Milan event"
},
]

const millan_photosfull = [
  { src: `${m1_big.src}` },
  { src: `${m2_big.src}` },
  { src: `${m3_big.src}` },
  { src: `${m4_big.src}` },
  { src: `${m5_big.src}` },
  { src: `${m6_big.src}` },
  { src: `${m7_big.src}` },
  { src: `${m8_big.src}` },
  { src: `${m9_big.src}` },
  { src: `${m10_big.src}` },
  { src: `${m11_big.src}` },
 
]

const eventsPhotos=[
  { src: `${E1.src}`, width: 237, height: 227,
  srcSet: [
    { src: `${E1.src}`, width: 237, height: 227 },
    { src: `${E1_2x.src}`, width: 474, height: 454 },
  ],
  alt:"Ashlok Safe Earthing Electrode Limited trade show booth showcasing advanced earthing and protection systems"
},

  { src: `${E2.src}`, width: 237, height: 227,srcSet: [
    { src: `${E2.src}`, width: 237, height: 227 },
    { src: `${E2_2x.src}`, width: 474, height: 454 },
  ],
  alt:"OmegaKraft exhibition booth displaying electrical panel systems and lightning protection products"
},
  { src: `${E3.src}`, width: 237, height: 227,srcSet: [
    { src: `${E3.src}`, width: 237, height: 227 },
    { src: `${E3_2x.src}`, width: 474, height: 454 },
  ],
  alt:"Ashlok lightning protection products displayed at a trade show for industrial protection solutions" 
},
  // { src: `${E4}`, width: 237, height: 227,srcSet: [
  //   { src: `${E4}`, width: 237, height: 227 },
  //   { src: `${E4_2x}`, width: 474, height: 454 },
  // ], },
  { src: `${E5.src}`, width: 237, height: 227,srcSet: [
    { src: `${E5.src}`, width: 237, height: 227 },
    { src: `${E5_2x.src}`, width: 474, height: 454 },
  ],
  
  alt:"Ashlok Safe Earthing Electrode Limited booth display featuring partner companies and products"
},
  { src: `${E6.src}`, width: 237, height: 227,srcSet: [
    { src: `${E6.src}`, width: 237, height: 227 },
    { src: `${E6_2x.src}`, width: 474, height: 454 },
  ],
  alt:"Ashlok Safe Earthing Electrode Limited trade show booth lounge area for business meetings"
},
  { src: `${E7.src}`, width: 237, height: 227,srcSet: [
    { src: `${E7.src}`, width: 237, height: 227 },
    { src: `${E7_2x.src}`, width: 474, height: 454 },
  ], 
  alt:"Ashlok Safe Earthing Electrode Limited product range showcasing earthing and lightning protection systems"
},
  { src: `${E8.src}`, width: 237, height: 227,srcSet: [
    { src: `${E8.src}`, width: 237, height: 227 },
    { src: `${E8_2x.src}`, width: 474, height: 454 },
  ],
  alt:"Ashlok BackFill Compound series display including Zetalite, Electrodrite, Conductolite, Terraion, and Humidite"
},
  { src: `${E9.src}`, width: 237, height: 227,srcSet: [
    { src: `${E9.src}`, width: 237, height: 227 },
    { src: `${E9_2x.src}`, width: 474, height: 454 },
  ],
  alt:"Ashlok Safe Earthing Electrode Limited grand booth displaying advanced earthing protection products at a trade show"
},
  { src: `${E10.src}`, width: 237, height: 227,srcSet: [
    { src: `${E10.src}`, width: 237, height: 227 },
    { src: `${E10_2x.src}`, width: 474, height: 454 },
  ],
alt:"Baron Minerals Pvt. Ltd. exhibition booth showcasing grounding and bonding equipment"
 },
  { src: `${E11.src}`, width: 237, height: 227,srcSet: [
    { src: `${E11.src}`, width: 237, height: 227 },
    { src: `${E11_2x.src}`, width: 474, height: 454 },
  ],
  alt:"Ashlok Safe Earthing Electrode Limited exhibition booth displaying earthing and lightning protection systems"
},
  { src: `${E12.src}`, width: 237, height: 227,srcSet: [
    { src: `${E12.src}`, width: 237, height: 227 },
    { src: `${E12_2x.src}`, width: 474, height: 454 },
  ],
alt:"Ashlok Safe Earthing Electrode Limited trade booth showcasing earthing electrodes and lightning protection systems"
},
  { src: `${E13.src}`, width: 237, height: 227,srcSet: [
    { src: `${E13.src}`, width: 237, height: 227 },
    { src: `${E13_2x.src}`, width: 474, height: 454 },
  ], 
  alt:"Ashlok Safe Earthing Electrode Limited product showcase featuring copper bonded rods and protection systems"
},
  { src: `${E14.src}`, width: 237, height: 227,srcSet: [
    { src: `${E14.src}`, width: 237, height: 227 },
    { src: `${E14_2x.src}`, width: 474, height: 454 },
  ],
  alt:"Ashlok Safe Earthing Electrode Limited booth at a trade show featuring earthing and lightning protection products"
   },
  { src: `${E15.src}`, width: 237, height: 227,srcSet: [
    { src: `${E15.src}`, width: 237, height: 227 },
    { src: `${E15_2x.src}`, width: 474, height: 454 },
  ], 
  alt:"Ashlok Safe Earthing Electrode Limited booth at a trade show featuring earthing and lightning protection products"
},
  { src: `${E16.src}`, width: 237, height: 227,srcSet: [
    { src: `${E16.src}`, width: 237, height: 227 },
    { src: `${E16_2x.src}`, width: 474, height: 454 },
  ],
  alt:"shlok Safe Earthing Electrode Limited product display featuring earthing electrodes and lightning protection systems at trade show"
},
  { src: `${E17.src}`, width: 237, height: 227,srcSet: [
    { src: `${E17.src}`, width: 237, height: 227 },
    { src: `${E17_2x.src}`, width: 474, height: 454 },
  ], 
  alt:"Ashlok Safe Earthing Electrode Limited circular booth design displaying earthing solutions at trade exhibition"
},


];

const events_photosfull = [
  { src: `${E1_big.src}` },
  { src: `${E2_big.src}` },
  { src: `${E3_big.src}` },
  // { src: `${E4_big}` },
  { src: `${E5_big.src}` },
  { src: `${E6_big.src}` },
  { src: `${E7_big.src}` },
  { src: `${E8_big.src}` },
  { src: `${E9_big.src}` },
  { src: `${E10_big.src}` },
  { src: `${E11_big.src}` },
  { src: `${E12_big.src}` },
  { src: `${E13_big.src}` },
  { src: `${E14_big.src}` },
  { src: `${E15_big.src}` },
  { src: `${E16_big.src}` },
  { src: `${E17_big.src}` },
]
const mediaPhotos=[];
const certificationsPhotos=[

  { src: `${CE1.src}`, width: 237, height: 227,srcSet: [
    { src: `${CE1.src}`, width: 237, height: 227 },
    { src: `${CE1_2x.src}`, width: 474, height: 454 },
  ],
    alt:"Ashlok Safe Earthing Electrode Limited CPRI test report for earthing electrode withstanding peak current" 
  },
  { src: `${CE2.src}`, width: 237, height: 227,srcSet: [
    { src: `${CE2.src}`, width: 237, height: 227 },
    { src: `${CE2_2x.src}`, width: 474, height: 454 },
  ], 
  alt:"Ashlok Safe Earthing Electrode Limited test certificate from TCR Engineering Services Pvt. Ltd"
},
  { src: `${CE3.src}`, width: 237, height: 227,srcSet: [
    { src: `${CE3.src}`, width: 237, height: 227 },
    { src: `${CE3_2x.src}`, width: 474, height: 454 },
  ],
    alt:"Ashlok Safe Earthing Electrode Limited UL Certificate of Compliance for copper bonded rod"
   },
  { src: `${CE4.src}`, width: 237, height: 227,srcSet: [
    { src: `${CE4.src}`, width: 237, height: 227 },
    { src: `${CE4_2x.src}`, width: 474, height: 454 },
  ], 
  alt:"Ashlok Safe Earthing Electrode Limited official test report from CPRI, March 2020"
  },
  { src: `${CE5.src}`, width: 237, height: 227,srcSet: [
    { src: `${CE5.src}`, width: 237, height: 227 },
    { src: `${CE5_2x.src}`, width: 474, height: 454 },
  ], 
  alt:"Ashlok Safe Earthing Electrode Limited CPRI test report for earthing electrode compliance"
},
  { src: `${CE6.src}`, width: 237, height: 227,srcSet: [
    { src: `${CE6.src}`, width: 237, height: 227 },
    { src: `${CE6_2x.src}`, width: 474, height: 454 },
  ],
  alt:"Ashlok Safe Earthing Electrode Limited CPRI test report for lightning impulse current test on earthing electrodes"
 },
  { src: `${CE7.src}`, width: 237, height: 227,srcSet: [
    { src: `${CE7.src}`, width: 237, height: 227 },
    { src: `${CE7_2x.src}`, width: 474, height: 454 },
  ],
  alt:"Ashlok Safe Earthing Electrode Limited test report by Spectro Analytical Labs Pvt. Ltd."
},
  { src: `${CE8.src}`, width: 237, height: 227,srcSet: [
    { src: `${CE8.src}`, width: 237, height: 227 },
    { src: `${CE8_2x.src}`, width: 474, height: 454 },
  ],
  alt:"Ashlok Safe Earthing Electrode Limited test report by Spectro Analytical Labs Pvt. Ltd."
},
  { src: `${CE9.src}`, width: 237, height: 227,srcSet: [
    { src: `${CE9.src}`, width: 237, height: 227 },
    { src: `${CE9_2x.src}`, width: 474, height: 454 },
  ],
  alt:"Ashlok Safe Earthing Electrode Limited ISO 9001:2015 certificate for earthing and lightning protection systems"
},
  
  { src: `${CE10.src}`, width: 237, height: 227,srcSet: [
    { src: `${CE10.src}`, width: 237, height: 227 },
    { src: `${CE10_2x.src}`, width: 474, height: 454 },
  ],
  alt:"Ashlok Safe Earthing Electrode Limited ICMET Craiova High Voltage Division test report for lightning conductor"
 },
  { src: `${CE11.src}`, width: 237, height: 227,srcSet: [
    { src: `${CE11.src}`, width: 237, height: 227 },
    { src: `${CE11_2x.src}`, width: 474, height: 454 },
  ],
  alt:"Ashlok Safe Earthing Electrode Limited official test report from CPRI, March 2020"
},
  { src: `${CE12.src}`, width: 237, height: 227,srcSet: [
    { src: `${CE12.src}`, width: 237, height: 227 },
    { src: `${CE12_2x.src}`, width: 474, height: 454 },
  ],
  alt:"Ashlok Safe Earthing Electrode Limited test report from Hizal High Voltage Test Lab, Turkey"
},

];
const certificationsPhotosfull=[
  { src: `${CE1_big.src}` },
  { src: `${CE2_big.src}` },
  { src: `${CE3_big.src}` },
  { src: `${CE4_big.src}` },
  { src: `${CE5_big.src}` },
  { src: `${CE6_big.src}` },
  { src: `${CE7_big.src}` },
  { src: `${CE8_big.src}` },
  { src: `${CE9_big.src}` },
  { src: `${CE10_big.src}` },
  { src: `${CE11_big.src}` },
  { src: `${CE12_big.src}` },
];



const allPhotos = [...eventsPhotos, ...milanPhotos, ...company_photos, ...certificationsPhotos]; // Combine all photos
const allbig_Photos = [...events_photosfull, ...millan_photosfull, ...company_photosfull, ...certificationsPhotosfull]; // Combine all photos

const renderRowContainer = ({ rowContainerProps, rowIndex, rowsCount, children }) => (
  <>
    <div {...rowContainerProps}>{children}</div>
    {rowIndex < rowsCount - 1 && (
      <div
        // style={{
        //   borderTop: "5px solid #eee",
        //   marginBottom: "20px",
        // }}
      />
    )}
  </>
);

function renderNextImage(
  alt = "", title, sizes ,photo, width, height 
) {
  //console.log(photo);
  return (
    
    <div
      style={{
        width: "100%",
        position: "relative",
        aspectRatio: `${width} / ${height}`,
      }}
    >
      <Image
        fill
        src={photo}
        alt={alt}
        title={title}
        sizes={sizes}
      //  placeholder={"blurDataURL" in photo ? "blur" : undefined}
      />
    </div>
  );
}

export default function GalleryPageContent() {
    const [open, setOpen] = useState(false);
    const [index, setIndex] = useState(-1);
    const [openMenuIndex, setOpenMenuIndex] = useState(null);
    const [selectedSection, setSelectedSection] = useState('all');

    const containerRef = useRef(null);
    const photoRefs = useRef([]);
    const getPhotosBySection = (section) => {
      switch (section) {
        case 'events':
          return eventsPhotos;
        case 'milan':
          return milanPhotos;
        case 'media':
          return company_photos;
        case 'certifications':
          return certificationsPhotos;
        case 'all':
        default:
          return allPhotos;
      }
    };

    const getBigPhotosBySection = (section) => {
      switch (section) {
        case 'events':
          return events_photosfull;
        case 'milan':
          return millan_photosfull;
        case 'media':
          return company_photosfull;
        case 'certifications':
          return certificationsPhotosfull;
        case 'all':
        default:
          return allbig_Photos;
      }
    };
  
    const photos = getPhotosBySection(selectedSection);
    const photosfull = getBigPhotosBySection(selectedSection);

    //console.log(photos);

    useEffect(() => {
         if (containerRef.current) {
          const containerHeight = containerRef.current.scrollHeight;
          const viewportHeight = window.innerHeight;
          const scrollHeight = containerHeight - viewportHeight;
    
          // Delay the scroll animation by 1 minute (60000 milliseconds)
          setTimeout(() => {
          gsap.to(window, {
            scrollTo: {
              y:'max', //   y: scrollHeight, Scroll to the bottom of the page
              autoKill: true
            },
            duration: 15, // Duration of the scroll in seconds
            ease: 'none',  // power2.inOut
          });

         },15000); // 60000 milliseconds = 1 minute
        }
    }, [photos]);

    const handleClick = (index) => {
      //console.log('Clicked photo index:', index);
      setIndex(index);
    };
    const photosWithIndex = photos.map((photo, index) => ({ photo, index }));

  return (
    <div>
         {/* <PreHeader/>
 
    <Header/>
      <Menu/> */}
      <ContactBanner     page="Why" banalt="Ashlok Safe Earthing Electrode Limited gallery banner showcasing company milestones and achievements" bannertext="" ban1x={gallery_banner} ban2x={gallery_banner2x} ban360={gallery_banner_360} bantab={gallery_banner_tab} />
                      <div className=' flex flex-col  lg:flex-row items-center justify-center my-3 lg:space-x-2' style={{zIndex:'300'}} >
                          {/*}  <p className='text-3xl text-ashred  '>Earthing System </p>  style={{zIndex:'10'}} */}
                            
                            <button
                            onClick={() => setSelectedSection('events')}
                            className={`px-[3.3em]  lg:px-12 py-2 my-1  lg:my-0   bg-ashred2 text-white rounded-full hover:bg-ashred      ${selectedSection === 'events' ? 'focus:outline-none focus:ring-2 focus:ring-red-500' : 'bg-gray-500'}`}>
                                 Events
                            </button>
                            <button 
                            onClick={() => setSelectedSection('milan')}
                            className={`px-[3.6em] lg:px-12 py-2 my-1  lg:my-0 bg-ashred2 text-white rounded-full hover:bg-ashred  ${selectedSection === 'milan' ? 'focus:outline-none focus:ring-2 focus:ring-red-500' : 'bg-gray-500'}`}>
                            Milan
                            </button>
                            <button 
                            onClick={() => setSelectedSection('media')}
                            className={`px-[2.8em] lg:px-10 py-2 my-1  lg:my-0 bg-ashred2 text-white rounded-full hover:bg-ashred ${selectedSection === 'media' ? 'focus:outline-none focus:ring-2 focus:ring-red-500':'bg-gray-500'} `}>
                            Ad media
                            </button>
                            <button 
                            onClick={() => setSelectedSection('certifications')}
                            className={`px-[1.9em]  lg:px-6 py-2 my-1  lg:my-0 bg-ashred2 text-white rounded-full hover:bg-ashred ${selectedSection === 'certifications' ? 'focus:outline-none focus:ring-2 focus:ring-red-500':'bg-gray-500'} `}>
                            Certifications
                            </button>
                            <button
                            onClick={() => setSelectedSection('all')}
                            className={`px-[4.2em] lg:px-14 py-2 my-1 lg:my-0 bg-ashred2 text-white rounded-full hover:bg-ashred      ${selectedSection === 'all' ? 'focus:outline-none focus:ring-2 focus:ring-red-500' : 'bg-gray-500'}`}>
                                 All
                            </button>

                        </div>
          <div className='w-full flex'>
          
          <div className='w-full px-1 pb-3'>
         
          
            <div className="photo-album-container" ref={containerRef}>

            {/* <RowsPhotoAlbum
        photos={photos}
        render={{ image: renderNextImage }}
        defaultContainerWidth={1200}
        sizes={{
          size: "100px",
          sizes: [{ viewport: "(max-width: 1200px)", size: "calc(100vw - 32px)" }],
        }}
      /> */}

            {/* <RowsPhotoAlbum photos={photos} layout="rows" /> */}
             <RowsPhotoAlbum layout="masonry"  
              photos={photos} 
             // targetRowHeight={200}
             // targetRowWidth={150}
              // spacing={2}
              // padding={5}
              // sizes="(max-width: 1200px) 16vw, 200px"
              //render={ renderNextImage }
              // defaultContainerWidth={1200}
              // sizes={{
              //   size: "100%",
              //   sizes: [
              //     { viewport: "(max-width: 1200px)", size: "calc(100vw - 32px)" },
              //   ],
              // }}
              //             renderContainer={({ children }) => (
    //   <div
    //     className="react-photo-album react-photo-album--masonry"
    //     style={{
    //       display: "flex",
    //       flexFlow: "row",
    //       justifyContent: "space-between",
    //     }}
    //   >
    //     {children}
    //   </div>
    // )}
    //            renderPhoto={({ photo, layout, layoutOptions }) => {
    //              // Debug the values
    // console.log('Photo:', photo);
    // console.log('Layout:', layout);
    // console.log('Layout Options:', layoutOptions);
    
    // return (
    //               <Image
    //                 src={photo.src}
    //                 alt={photo.alt || ""}
    //                 width={layout.width}
    //                 height={layout.height}
    //                 sizes={layoutOptions.sizes}
    //                 placeholder="blur"
    //                 blurDataURL={photo.blurDataURL}
                   
    //               />
    // );
    //            }}
             
               onClick={({ index }) => setIndex(index)}
        
               />
               
               
               </div>
               
             <Lightbox
        //slides={photosfull}
        slides={photosfull.map(photo => ({ src: photo.src }))}
        open={index >= 0}
        index={index}
        close={() => setIndex(-1)}
        
       plugins={[ Slideshow /*, Fullscreen,Zoom*/]}
                /> 
               
             </div>
             <ScrollToTopButton/>
          </div>
          <ProductProvider>
                <Footer/>
            </ProductProvider>
          </div>
          )
   
  
}

